(function () {
    'use strict';

    angular
        .module('app')
        .controller('CompleteTaskDialogCtrl', CompleteTaskDialogCtrl);

    CompleteTaskDialogCtrl.$inject = [
        'DialogInstance',
        'complete',
        'prefilledNote'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for completing/uncompleting tasks
     *
     * @param {bool} complete - True if it's a complete operation, otherwise it will be handled as uncomplete.
     * @param {string} prefilledNote - Text used to pre-fill the Complete/Uncomplete Note.
     */
    function CompleteTaskDialogCtrl(
        DialogInstance,
        complete,
        prefilledNote) {
        /* jshint validthis:true */
        var vm = this;
        vm.note = prefilledNote ? prefilledNote : '';
        vm.cancel = cancel;
        vm.ok = ok;
        Object.defineProperty(vm, 'title', {
            get: function () {
                return (complete ? 'Complete' : 'Uncomplete') + ' Task(s)';
            }
        });

        function ok() {
            DialogInstance.ok(vm.note);
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
